import { User } from '@wilson/interfaces';
import { isNonAccessibleUser, NonAccessibleUser } from './types';

export function excludeCurrentRealtimeViewer<
  T extends User | NonAccessibleUser,
>(viewers: T[] | null | undefined, currentUserId: string | null): T[] {
  if (!Array.isArray(viewers)) {
    return [];
  }

  if (!currentUserId) {
    return viewers;
  }

  return viewers.filter((viewer) => {
    if (isNonAccessibleUser(viewer)) {
      return true;
    }

    return viewer.id !== currentUserId;
  });
}
